module.exports = __webpack_public_path__ + "static/media/main3.8a98ff9f.jpeg";